import React, { useEffect, useState } from 'react'
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Stack,
  TextField,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export default function CrearVendedorForm({ open, onClose, title = 'Nuevo vendedor', submitLabel = 'Crear vendedor', form, onChange, onSubmit, error, loading = false }) {
  const disabled = Boolean(loading)
  const [touched, setTouched] = useState({})

  useEffect(() => {
    if (!open) setTouched({})
  }, [open])

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/
    return emailRegex.test(email)
  }

  const validateField = (fieldName) => {
    if (fieldName === 'nombre') {
      return !form.nombre || String(form.nombre).trim() === '' ? 'El nombre es requerido' : ''
    }
    if (fieldName === 'email') {
      if (!form.email || String(form.email).trim() === '') return 'El email es requerido'
      if (!isValidEmail(form.email)) return 'El email no es válido'
    }
    return ''
  }

  const handleBlur = (fieldName) => {
    setTouched((prev) => ({ ...prev, [fieldName]: true }))
  }

  const isFormValid = !validateField('nombre') && !validateField('email')

  const formatPhone = (raw) => {
    const d = String(raw || '').replace(/\D/g, '')
    const a = d.slice(0, 3)
    const b = d.slice(3, 6)
    const c = d.slice(6, 10)
    return b ? `${a} ${b}${c ? '-' + c : ''}` : a
  }

  const handleSubmitLocal = (e) => {
    e?.preventDefault?.()
    if (!isFormValid) return
    onSubmit?.(e)
  }

  return (
    <Dialog open={open} onClose={disabled ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box component="span" sx={{ fontWeight: 700 }}>{title}</Box>
          <IconButton aria-label="close" onClick={onClose} size="small" disabled={disabled}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {loading && <LinearProgress />}

      <DialogContent sx={{ position: 'relative' }}>
        <Backdrop open={loading} sx={{ position: 'absolute', zIndex: (t) => t.zIndex.drawer + 1, color: '#fff' }} invisible={!loading}>
          {loading && <CircularProgress />}
        </Backdrop>

        <Stack spacing={2} sx={{ mb: 2 }}>
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>

        <Box component="form" onSubmit={handleSubmitLocal} sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
          <Box sx={{ gridColumn: 'span 2' }}>
            <TextField
              label="Nombre"
              fullWidth
              name="nombre"
              value={form.nombre}
              onChange={onChange}
              onBlur={() => handleBlur('nombre')}
              disabled={disabled}
              required
              error={Boolean(touched.nombre && validateField('nombre'))}
              helperText={touched.nombre ? validateField('nombre') : ''}
            />
          </Box>

          <TextField
            label="Teléfono"
            fullWidth
            name="telefono"
            value={formatPhone(form.telefono)}
            onChange={onChange}
            disabled={disabled}
            inputProps={{ inputMode: 'numeric' }}
            placeholder="123 456-7890"
          />

          <TextField
            label="Email"
            type="email"
            fullWidth
            name="email"
            value={form.email}
            onChange={onChange}
            onBlur={() => handleBlur('email')}
            disabled={disabled}
            inputProps={{ inputMode: 'email' }}
            required
            error={Boolean(touched.email && validateField('email'))}
            helperText={touched.email ? validateField('email') : ''}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ pr: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={disabled} color="inherit">Cancelar</Button>
        <Button onClick={handleSubmitLocal} variant="contained" disabled={disabled || !isFormValid}>
          {loading ? 'Guardando...' : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
